<template>
  <div class="dea-checkbox-search-list">
    <div class="dea-checkbox-search-list__label-container">
      <p class="dea-checkbox-search-list__label">{{ label }}</p>
    </div>
    <div v-if="useInput" class="dea-checkbox-search-list__input-container">
      <input
        type="text"
        :placeholder="placeholder"
        class="dea-checkbox-search-list__input"
        @keyup="triggerAutosuggest"
      />
    </div>
    <div class="dea-checkbox-search-list__list-container">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "ListSearchCheckbox",
  props: {
    placeholder: {
      type: String,
      default: "Cosa stai cercando?",
    },
    label: {
      type: String,
      default: "",
    },
    useInput: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    triggerAutosuggest(e) {
      this.$emit("trigger-autosuggest", e.target.value);
    },
  },
};
</script>
